import React, { useRef, useState, useCallback, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Dropdown, Button, Spinner, ToastContainer, Toast, Row, Col, Modal } from "react-bootstrap";
import DOMPurify from "dompurify";
import CommonTooltip from "../common/common_tooltip";
import ErrorExtractor from "../common/error_extractor";
import CommonDropdown from "../common/common_dropDown";
import { submitTransactionAPI, saveAttachmentApi, updateTransactionAPI, getTransactionEditApi, getPODetailsApi, extractBillApi } from "../transaction/transaction_api";
import addImage from "../../assets/svg/add-image.svg";
import upload from "../../assets/svg/upload.svg";
import attachment from "../../assets/png/attachment.png";
import download from "../../assets/svg/download.svg";
import closeAttachment from "../../assets/svg/close-red.svg";
import closeModal from "../../assets/svg/close-modal.svg";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import { useGlobal } from "../../GlobalContext";
import DatePicker from "react-datepicker";
import "./trans.css";
import deleteIcon from "../../assets/svg/delete-po.svg";
import { getProductDetailsApi, submitCategoryApi } from "../PurchaseOrder/po-api";
import { ReactComponent as InfoIc } from "../../assets/svg/info_ic.svg";
import SearchWithFreeText from "../common/common_auto_freesuggestion";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { getVendorAddress } from "../purchase-quotation/pq-api";
import ProfileImageModal from "../common/common-preview";
import backArrow from "../../assets/svg/back_arrow.svg";
import scanIcon from "../../assets/svg/scan.svg";
import attachPin from "../../assets/svg/attach_pin.svg";
import calendarIcon from "../../assets/svg/calander.svg";
import addPlus from "../../assets/svg/add_plus.svg";
import addAttach from "../../assets/svg/add_attach.svg";
import cameraIcon from "../../assets/svg/cemera.svg";
import fileAdd from "../../assets/svg/file_add.svg";
import personIcon from "../../assets/svg/person_ic.svg";
import pdfIcon from "../../assets/svg/pdf.svg";
import trashIcon from "../../assets/svg/trash.svg";
import deleteBtn from "../../assets/svg/delete_btn.svg";
import AmountSummary from "../common/AmountSummary";

export const TransactionCreate = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { headerDetails } = useGlobal();

  const decodeHtml = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  const location = useLocation();
  const navigate = useNavigate();

  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  const openFile = (fileUrl = "", fileName = "") => {
    // prefer filename extension (CREATE flow)
    const source = (fileName || fileUrl).toLowerCase();
    const cleanSource = source.split("?")[0];

    // 🖼 Images → popup
    if (cleanSource.endsWith(".png") || cleanSource.endsWith(".jpg") || cleanSource.endsWith(".jpeg") || cleanSource.endsWith(".gif") || cleanSource.endsWith(".webp")) {
      if (!fileUrl) return; // no preview without URL
      setSelectedProfile(fileUrl);
      setShowProfilePopup(true);
      return;
    }

    // 📄 PDF → open directly
    if (cleanSource.endsWith(".pdf")) {
      if (!fileUrl) return;
      setSelectedProfile(fileUrl);
      setShowProfilePopup(true);
      return;
    }

    // 📊 Office files → Office Viewer
    if (cleanSource.endsWith(".xls") || cleanSource.endsWith(".xlsx") || cleanSource.endsWith(".doc") || cleanSource.endsWith(".docx") || cleanSource.endsWith(".ppt") || cleanSource.endsWith(".pptx")) {
      if (!fileUrl) return;

      const officeViewerUrl = "https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(fileUrl);

      window.open(officeViewerUrl, "_blank", "noopener,noreferrer");
      return;
    }

    // ⬇ Fallback
    if (fileUrl) {
      window.open(fileUrl, "_blank", "noopener,noreferrer");
    }
  };
  const { id } = location.state || {};
  const [isLoader, setIsLoader] = useState(false);
  const [isSaveLoader, setIsSaveLoader] = useState(false);

  useEffect(() => {
    if (id != null) {
      getTransEdit(id);
    }
  }, [id]);

  useEffect(() => {
    if (id == null && headerDetails) {
      setCreatedBy(`${headerDetails.first_name ?? ""} ${headerDetails.last_name ?? ""}`.trim());
    }
  }, [headerDetails, id]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const fileInputRef = useRef(null);
  const [isScanAction, setIsScanAction] = useState(false);
  const [isRoundOff, setIsRoundOff] = useState(false);
  const [image, setImage] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [attachmentList, setAttachmentList] = useState([]);
  const [removedAttachmentList, setRemovedAttachmentList] = useState([]);
  const [isScanLoading, setIsScanLoading] = useState(false);
  const [isScanned, setIsScanned] = useState(false);
  const [scanningFile, setScanningFile] = useState(null);
  const [scannedFiles, setScannedFiles] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState("₹");

  // const [activeBtn, setActiveBtn] = useState("details");
  const handleInputFile = () => {
    fileInputRef.current.click();
  };

  const handleScanClick = () => {
    setIsScanAction(true);
    setShowUploadModal(true);
  };

  const extractBill = async (base64String) => {
    setIsScanLoading(true);
    try {
      const body = {
        file: base64String,
        type: "transaction",
      };
      const response = await extractBillApi(body);
      if (response?.data?.success) {
        const data = response.data.response;
        setTransactionType(data.trans_type || "Direct");
        setVendorOption({ value: data.vendor_id, label: data.vendor_name || "Extracted Vendor" });
        setRemarks(data.remarks || "");
        if (data.trans_date) {
          setPaymentDate(new Date(data.trans_date));
        }

        const extractedProducts = (data.products || []).map((item) => {
          const qty = toNumber(item.quantity);
          const rate = toNumber(item.unit_amount);
          const cgstP = toNumber(item.cgst_percentage);
          const sgstP = toNumber(item.sgst_percentage);
          const igstP = toNumber(item.igst_percentage);

          const baseAmount = qty * rate;
          const taxAmount = (baseAmount * (cgstP + sgstP + igstP)) / 100;
          const totalWithTax = baseAmount + taxAmount;

          return {
            ...item,
            product: { value: item.product_id, label: `${item.product || ""} - ${item.product_code || ""}` },
            product_code: item.product_code || "",
            quantity: qty,
            unit_amount: rate,
            amount: totalWithTax.toFixed(2),
            total_amount: totalWithTax.toFixed(2),
            cgst_percentage: cgstP,
            sgst_percentage: sgstP,
            igst_percentage: igstP,
          };
        });
        setProductList(extractedProducts);

        if (data.vendor_id) {
          getAddress(data.vendor_id);
        }

        setIsScanned(true);
        if (scanningFile) {
          setScannedFiles((prev) => [...prev, scanningFile]);
        }
        setSnackbarMessage("Bill extracted successfully");
        setSnackbarStatus(true);
        handleSnackbarShow();
      } else {
        setSnackbarMessage(response?.data?.message || "Extraction failed");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error extracting bill:", err);
      setSnackbarMessage(err.response?.data?.message || "Error extracting bill");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsScanLoading(false);
      setScanningFile(null);
    }
  };

  const handleScanOnCard = async (fileUrl) => {
    try {
      setIsScanLoading(true);
      setScanningFile(fileUrl);
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        extractBill(base64String);
      };
      reader.readAsDataURL(blob);
    } catch (error) {
      console.error("Error scanning card file:", error);
      setIsScanLoading(false);
    }
  };

  const handleClear = () => {
    setTransactionType("Direct");
    setVendorOption(null);
    setPurchaseOrderOption(null);
    setProjectOption(null);
    setPaymentTypeOption(null);
    setRemarks("");
    setPaymentDate(new Date());
    setProductList([]);
    setAttachmentList([]);
    setAttachmentURLList([]);
    setRemovedAttachmentList([]);
    setPaidAmount("");
    setBalanceAmount("");
    setTotalAmount("");
    setAdjustment(0);
    setIsAdd(true);
    setRemovedProducts([]);
    setErrorMsg({});
    setSearchCategory("");
    setSelectedCategory(null);
    setVendor("");
    setIsScanned(false);
    setIsScheduled(false);
    setIsRoundOff(false);
    setCurrencySymbol("₹");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const validateUploadedFile = (file) => {
    const allowedExtensions = ["png", "jpg", "jpeg", "pdf", "doc", "docx", "xls", "xlsx", "csv"];
    const fileExtension = file.name.split(".").pop().toLowerCase();
    
    if (!allowedExtensions.includes(fileExtension)) {
      setErrorMsg(prev => ({
        ...prev,
        attachment: `Unsupported file format: ${file.name}! Supported formats: JPG, JPEG, PNG, PDF, DOC, DOCX, XLS, XLSX, CSV`
      }));
      return false;
    }

    const fileSizeMB = file.size / (1024 * 1024);
    if (fileSizeMB > 5) {
      setErrorMsg(prev => ({
        ...prev,
        attachment: `File size of ${file.name} exceeds 5MB! Maximum file size supported is 5MB.`
      }));
      return false;
    }

    setErrorMsg(prev => ({ ...prev, attachment: "" }));
    return true;
  };

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);

    if (isScanAction && files.length > 0) {
      const scanFile = files[0];
      if (!validateUploadedFile(scanFile)) {
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      const scanReader = new FileReader();
      scanReader.onload = async () => {
        const base64String = scanReader.result.split(",")[1];
        extractBill(base64String);
      };
      scanReader.readAsDataURL(scanFile);
      setIsScanAction(false);
      setAttachmentList([]);
      setAttachmentURLList([]);
    }

    const validFiles = files.filter(file => validateUploadedFile(file));

    validFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result;
        setAttachmentList((prev) => [
          ...prev,
          {
            name: file.name,
            base64: base64String,
            size: formatBytes(file.size),
          },
        ]);
      };
      reader.readAsDataURL(file);
    });
  };
  const formatBytes = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);

    const files = Array.from(event.dataTransfer.files);
    const validFiles = files.filter(file => validateUploadedFile(file));

    validFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result;
        setAttachmentList((prev) => [
          ...prev,
          {
            name: file.name,
            base64: base64String,
            size: formatBytes(file.size),
          },
        ]);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleModalFileChange = (event) => {
    const files = Array.from(event.target.files);
    const validFiles = files.filter(file => validateUploadedFile(file));

    validFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = await reader.result;
        setTempAttachmentList((prev) => [
          ...prev,
          {
            name: file.name,
            base64: base64String,
            size: formatBytes(file.size),
            type: file.type,
          },
        ]);
      };
      reader.readAsDataURL(file);
    });
  };

  const handleModalUpload = () => {
    if (isScanAction && tempAttachmentList.length > 0) {
      const scanFile = tempAttachmentList[0];
      const base64String = scanFile.base64.split(",")[1];
      extractBill(base64String);
      setIsScanAction(false);
      setAttachmentList(tempAttachmentList);
      setAttachmentURLList([]);
    } else {
      setAttachmentList((prev) => [...prev, ...tempAttachmentList]);
    }
    setTempAttachmentList([]);
    setShowUploadModal(false);
  };
  const handleDelete = () => {
    setImage(null);
    fileInputRef.current.value = "";
  };

  const downloadFile = (fileUrl, fileName) => {
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Download error:", error));
  };

  const [transactionType, setTransactionType] = useState("Direct");

  const [purchaseOrderOption, setPurchaseOrderOption] = useState(null);
  const [projectOption, setProjectOption] = useState(null);
  const [paidAmount, setPaidAmount] = useState("");
  const [paymentTypeOption, setPaymentTypeOption] = useState(null);
  const [balanceAmount, setBalanceAmount] = useState("");
  const [payingAmount, setPayingAmount] = useState("");
  const [vendor, setVendor] = useState("");
  const [vendorOption, setVendorOption] = useState(null);
  const [totalAmount, setTotalAmount] = useState("");
  const [remarks, setRemarks] = useState("");
  const [paymentDate, setPaymentDate] = useState(new Date());
  const [productList, setProductList] = useState([]);
  const [adjustment, setAdjustment] = useState(0);
  const [isAdd, setIsAdd] = useState(true);
  const [isFirstTrans, setIsFirstTrans] = useState(true);
  const [removedProducts, setRemovedProducts] = useState([]);
  const [createdBy, setCreatedBy] = useState("");
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [tempAttachmentList, setTempAttachmentList] = useState([]);
  const [isCameraActive, setIsCameraActive] = useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);

  const startCamera = async () => {
    setIsCameraActive(true);
    setTimeout(async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
        }
      } catch (err) {
        console.error("Error accessing camera:", err);
        setIsCameraActive(false);
      }
    }, 100);
  };

  const stopCamera = () => {
    if (videoRef.current?.srcObject) {
      videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
    setIsCameraActive(false);
  };

  const capturePhoto = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (video && canvas) {
      const context = canvas.getContext("2d");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const dataUrl = canvas.toDataURL("image/png");
      const fileName = `capture_${Date.now()}.png`;
      const fileSize = formatBytes(Math.round((dataUrl.length * 3) / 4));

      if (isScanAction) {
        const base64String = dataUrl.split(",")[1];
        extractBill(base64String);
        setIsScanAction(false);
        setAttachmentList([{ name: fileName, base64: dataUrl, size: fileSize, type: "image/png" }]);
        setAttachmentURLList([]);
        setShowUploadModal(false);
      } else {
        setTempAttachmentList((prev) => [...prev, { name: fileName, base64: dataUrl, size: fileSize, type: "image/png" }]);
      }
      stopCamera();
    }
  };

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [searchCategory, setSearchCategory] = useState("");
  const [createCategoryModal, setCreateCategoryModal] = useState(false);
  const [categoryName, setCategoryName] = useState("");

  const handleDropdownCategoryChange = (option) => {
    console.log("Selected option:", option);
    setSelectedCategory(option);
    setSearchCategory(option.value ?? "");
  };

  const handleSearchCategoryChange = (value) => {
    console.log("Search input changed:", value);
    setSearchCategory(value);
    setSelectedCategory({ label: value, value: value });
  };

  const getPODetails = async (id) => {
    try {
      const response = await getPODetailsApi(id);

      if (response.data.success === true) {
        const poDetail = response.data.order ?? {};
        if (poDetail.currency_symbol) {
          setCurrencySymbol(decodeHtml(poDetail.currency_symbol));
        }
        setSearchCategory(poDetail.category_name ?? "");
        setSelectedCategory({
          label: poDetail.category_name ?? "",
          value: poDetail.category_id ?? "",
        });
        setPaidAmount(poDetail.paid_amount ?? "");
        setBalanceAmount(poDetail.balance_amount ?? "");
        setVendor(poDetail.vendor_name ?? "");
        getAddress(poDetail.vendor_id);
        setVendorOption({
          value: poDetail.vendor_id ?? "",
          label: poDetail.vendor_name ?? "",
        });
        setTotalAmount(poDetail.total_amount ?? "");
        setAdjustment(poDetail.adjustment ?? 0);
        setIsAdd(poDetail.is_add ?? true);
        setIsFirstTrans(poDetail.is_first_trans ?? true);
        setProjectOption({
          value: poDetail.project_id ?? "",
          label: poDetail.project_name ?? "",
        });
        setPaymentTypeOption({
          value: poDetail.payment_type ?? "",
          label: poDetail.payment_type ?? "",
        });
        const updatedData = poDetail.products.map((rest) => ({
          ...rest,
          id: 0,
          po_line_id: rest.id,
          unit_amount: rest.unit_price,
          quantity: 0,
          amount: 0,
        }));
        setProductList(updatedData ?? []);
        setRemovedProducts([]);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getProductDetails = async (id, index) => {
    try {
      const response = await getProductDetailsApi(id);

      if (response.data.success === true) {
        const productDetail = response.data.product ?? {};
        const productTemp = [...productList];
        productTemp[index]["product_code"] = productDetail.code ?? "";
        productTemp[index]["product_img"] = productDetail.image ?? "";
        setProductList(productTemp);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  useEffect(() => {
    setPayingAmount(productList.reduce((total, item) => total + toNumber(item.amount), 0));
  }, [productList]);

  const [errorMsg, setErrorMsg] = useState({
    trans_type: "",
    vendor_id: "",
    project_id: "",
    po_id: "",
    amount: "",
    payment_type_id: "",
    remarks: "",
    category: "",
    products: "",
    name: "",
  });
  const [groupedError, setGroupedError] = useState({});
  const submitForm = async () => {
    // Frontend validation
    const errors = {
      trans_type: "",
      vendor_id: "",
      project_id: "",
      po_id: "",
      amount: "",
      payment_type_id: "",
      products: "",
      remarks: "",
      category_id: "",
    };

    let hasErrors = false;

    if (transactionType === "Purchase-Order") {
      if (!purchaseOrderOption || !purchaseOrderOption.value) {
        errors.po_id = "Purchase Order is required";
        hasErrors = true;
      }
      if (!paymentTypeOption || !paymentTypeOption.value) {
        errors.payment_type_id = "Payment Type is required";
        hasErrors = true;
      }
    } else { // Direct
      if (!vendorOption || !vendorOption.value) {
        errors.vendor_id = "Vendor is required";
        hasErrors = true;
      }
      if (!paymentTypeOption || !paymentTypeOption.value) {
        errors.payment_type_id = "Payment Type is required";
        hasErrors = true;
      }
    }

    if (!payingAmount || Number(payingAmount) <= 0) {
      errors.amount = "Total Amount must be greater than 0";
      hasErrors = true;
    }

    if (!productList || productList.length === 0) {
      errors.products = "At least one product must be added";
      hasErrors = true;
    } else {
      const hasValidProduct = productList.some(item => Number(item.quantity) > 0);
      if (!hasValidProduct) {
        errors.products = "Product quantity must be greater than 0";
        hasErrors = true;
      }
    }

    if (isScheduled && paymentDate && paymentDate <= new Date()) {
      errors.trans_date = "Scheduled date & time must be in the future";
      hasErrors = true;
    }

    if (hasErrors) {
      setErrorMsg(errors);
      setSnackbarMessage("Please fill all mandatory fields correctly.");
      setSnackbarStatus(false);
      handleSnackbarShow();
      return;
    }

    setIsLoader(true);
    const extractor = new ErrorExtractor();
    try {
      const updatedData = productList.map((item) => ({
        ...item,
        product: null,
        proceed: item.proceed != null ? item.proceed : false,
        product_id: transactionType === "Purchase-Order" ? (item.product_id ?? "") : item.product != null ? item.product.value : "",
      }));
      const preSanitizeData = {
        trans_type: transactionType, //Purchase-Order|Direct
        vendor_id: vendorOption != null ? vendorOption.value : "",
        project_id: projectOption != null ? projectOption.value : "",
        po_id: purchaseOrderOption != null ? purchaseOrderOption.value : "",
        amount: payingAmount,
        payment_type_id: paymentTypeOption != null ? paymentTypeOption.value : "", // Cash,Credit,UPI
        remarks: remarks,
        trans_date: paymentDate != null && paymentDate !== "" ? paymentDate.toLocaleDateString("en-CA") + " " + paymentDate.toLocaleTimeString("en-GB") : "",
        products: updatedData,
        removed_products: removedProducts,
        category_id: selectedCategory != null ? selectedCategory?.value : 0,
        round_off: isRoundOff,
        status: isScheduled ? "Scheduled" : "",
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (typeof value === "boolean" || typeof value === "number" || Array.isArray(value) || key === "assignee") {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      var response = null;
      if (id == null) {
        response = await submitTransactionAPI(sanitizedData);
      } else {
        response = await updateTransactionAPI(id, sanitizedData);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400 || response.status === 422) {
        new Promise((resolve, reject) => {
          const groupedErrorTemp = {};
          const backendErrors = response.data.errors || response.data.error || {};
          Object.entries(backendErrors).forEach(([key, value]) => {
            // match tickets.index.field
            const match = key.match(/^products\.(\d+)\.(.+)$/);

            if (match) {
              const index = match[1]; // e.g. "0"
              const field = match[2]; // e.g. "closing_date"

              if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
              groupedErrorTemp[index][field] = value;
            }
          });
          setGroupedError(groupedErrorTemp);
          const validationTemp = {
            trans_type: "",
            vendor_id: "",
            project_id: "",
            po_id: "",
            amount: "",
            payment_type_id: "",
            products: "",
            remarks: "",
            category_id: "",
          };
          Object.entries(backendErrors).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = Array.isArray(value) ? (value[0] || "") : value;
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        console.log("saveAttachment called 0");
        if (attachmentList.length === 0 && removedAttachmentList.length === 0) {
          console.log("saveAttachment called 1");
          navigate(-1);
        } else {
          console.log("saveAttachment called 2");
          saveAttachment(response.data.id);
        }
      }
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (err.response && (err.response.status === 400 || err.response.status === 422)) {
        new Promise((resolve, reject) => {
          const groupedErrorTemp = {};
          const backendErrors = err.response.data.errors || err.response.data.error || {};
          Object.entries(backendErrors).forEach(([key, value]) => {
            // match tickets.index.field
            const match = key.match(/^products\.(\d+)\.(.+)$/);

            if (match) {
              const index = match[1]; // e.g. "0"
              const field = match[2]; // e.g. "closing_date"

              if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
              groupedErrorTemp[index][field] = value;
            }
          });
          setGroupedError(groupedErrorTemp);
        });

        const backendErrors = err.response.data.errors || err.response.data.error || {};
        const errorvalue = extractor.extractErrors({ ...err.response.data, error: backendErrors }, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
      }
    } finally {
      setIsLoader(false);
    }
  };
  const saveAttachment = async (parentId) => {
    console.log("saveAttachment called");
    try {
      const data = {
        removed_attachments: removedAttachmentList,
        attachments: attachmentList.map((item) => ({
          file_name: item.name,
          base64: item.base64,
        })),
      };
      const response = await saveAttachmentApi(parentId, data);
      if (response.data.success === true) {
        navigate(-1);
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  };

  const getTransEdit = async (id) => {
    try {
      const response = await getTransactionEditApi(id);

      if (response?.data?.success) {
        const transData = response.data.transaction || {};
        if (transData.currency_symbol) {
          setCurrencySymbol(decodeHtml(transData.currency_symbol));
        }
        setTransactionType(transData.trans_type ?? "");
        setVendorOption({ value: transData.vendor_id ?? "", label: transData.vendor ?? "" });
        setProjectOption({ value: transData.project_id ?? "", label: transData.project_name ?? "" });
        setPurchaseOrderOption({ value: transData.po_id ?? "", label: transData.po_no ?? "" });
        setPaymentTypeOption({ value: transData.payment_type_id ?? "", label: transData.payment_type ?? "" });
        setRemarks(transData.remarks ?? "");
        setPaymentDate(
          transData.trans_date
            ? new Date(transData.trans_date) // ✅ IMPORTANT FIX
            : null,
        );
        setIsRoundOff(Number(transData.round_diff) !== 0);
        setCreatedBy(transData.created_by_name || `${headerDetails?.first_name ?? ""} ${headerDetails?.last_name ?? ""}`.trim());
        getAddress(transData.vendor_id);
        setVendor(transData.vendor ?? "");
        setPaidAmount(transData.paid_amount ?? "");
        setBalanceAmount(transData.balance_amount ?? "");
        setSearchCategory(transData.category_name ?? "");
        setSelectedCategory({ value: transData.category_id ?? "", label: transData.category_name });
        setTotalAmount(transData.total_amount ?? 0);
        setAttachmentURLList(transData.attachments ?? []);
        setProductList(
          (transData.products ?? []).map((item) => ({
            ...item,
            product: { value: item.product_id, label: `${item.name} - ${item.code}` },
            balance_quantity: item.po_balance_quantity ?? "0",
            product_code: item.code,
            amount: item.total_amount ?? 0,
          })),
        );
      } else {
      }

      return response?.data;
    } catch (error) {
      console.error("Error fetching transaction edit:", error);
      return null;
    } finally {
      // 🔁 optional cleanup / loader stop
    }
  };

  const getErrorMsg = (index, field) => {
    if (field === "product_id") {
      if (groupedError[index] != null) {
        if (groupedError[index].product_id != null) {
          return groupedError[index].product_id[0]?.replace(`products.${index}.product_id`, "product") ?? "";
        }
      }
    }

    if (field === "quantity") {
      if (groupedError[index] != null) {
        if (groupedError[index].quantity != null) {
          return groupedError[index].quantity[0]?.replace(`products.${index}.quantity`, "quantity") ?? "";
        }
      }
    }
    if (field === "exception") {
      if (groupedError[index] != null) {
        if (groupedError[index].exception != null) {
          return groupedError[index].exception[0]?.replace(`products.${index}.exception`, "exception") ?? "";
        }
      }
    }
    if (field === "quantity") {
      if (groupedError[index] != null) {
        if (groupedError[index].quantity != null) {
          return groupedError[index].quantity[0]?.replace(`products.${index}.quantity`, "quantity") ?? "";
        }
      }
    }

    if (field === "amount") {
      if (groupedError[index] != null) {
        if (groupedError[index].amount != null) {
          return groupedError[index].amount[0]?.replace(`products.${index}.amount`, "amount") ?? "";
        }
      }
    }

    return "";
  };
  const updateProductDuplicTotal = (index, list) => {
    const productTemp = [...list];
    const product = productTemp[index];

    const baseAmount = Number(product.quantity || 0) * Number(product.unit_amount || 0);

    const cgstAmount = baseAmount * (Number(product.cgst_percentage || 0) / 100);
    const igstAmount = baseAmount * (Number(product.igst_percentage || 0) / 100);
    const sgstAmount = baseAmount * (Number(product.sgst_percentage || 0) / 100);

    const totalAmount = baseAmount + cgstAmount + igstAmount + sgstAmount;

    productTemp[index].total_amount = Math.round(totalAmount);
    productTemp[index].amount = Math.round(totalAmount);

    return productTemp; // Return updated list instead of setting state here
  };

  const updateProductTotal = (index) => {
    const productTemp = [...productList];
    const product = productTemp[index];

    const baseAmount = Number(product.quantity || 0) * Number(product.unit_amount || 0);

    // Tax calculations
    const cgstAmount = baseAmount * (Number(product.cgst_percentage || 0) / 100);
    const igstAmount = baseAmount * (Number(product.igst_percentage || 0) / 100);
    const sgstAmount = baseAmount * (Number(product.sgst_percentage || 0) / 100);

    const tdsAmount = baseAmount * (Number(product.tds_percentage || 0) / 100);

    const totalAmount = baseAmount + cgstAmount + igstAmount + sgstAmount;

    productTemp[index].total_amount = totalAmount.toFixed(2);
    productTemp[index].amount = totalAmount.toFixed(2);

    setProductList(productTemp);
  };
  const [isIgst, setIsIgst] = useState(false);
  const [isCgst, setIsCgst] = useState(false);
  const [isSgst, setIsSgst] = useState(false);
  const getAddress = async (id) => {
    try {
      const response = await getVendorAddress(id);
      if (response.data.success === true) {
        setIsIgst(response.data.data.igst ?? false);
        setIsCgst(response.data.data.cgst ?? false);
        setIsSgst(response.data.data.sgst ?? false);
      }
    } catch (e) {}
  };
  const handleCategorySave = async () => {
    if (isSaveLoader) return; // ⛔ prevent double click
    setIsSaveLoader(true);

    try {
      // clear previous errors
      setErrorMsg({});
      const payload = { name: categoryName };

      const response = await submitCategoryApi(payload);
      if (response.data.success) {
        setSnackbarMessage("Category created successfully!");
        setSnackbarStatus(true);
        handleSnackbarShow();
        setCreateCategoryModal(false);
        setSelectedCategory({ value: categoryName, label: categoryName });
        setCategoryName("");

        setErrorMsg({});
      } else {
        setErrorMsg(response.data.error || {});
        console.log(errorMsg);
        setSnackbarMessage(response.data.message || "Failed to create category.");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (error) {
      console.error(error);
      setSnackbarMessage("Error creating category.");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsSaveLoader(false); // ✅ always reset
    }
  };

  const toNumber = (v) => {
    if (v === null || v === undefined) return 0;
    const cleaned = String(v)
      .replace(/[^0-9.-]/g, "")
      .trim();
    const n = parseFloat(cleaned);
    return Number.isFinite(n) ? n : 0;
  };

  const calculateSummary = useCallback(() => {
    let subTotal = 0;
    let cgstTotal = 0;
    let sgstTotal = 0;
    let igstTotal = 0;

    const rows = productList;

    rows.forEach((row) => {
      const quantity = toNumber(row.quantity);

      // 🔹 price field differs by type
      const unitPrice = toNumber(row.unit_amount); // PO

      const base = quantity * unitPrice;
      subTotal += base;

      cgstTotal += base * (toNumber(row.cgst_percentage) / 100);
      sgstTotal += base * (toNumber(row.sgst_percentage) / 100);
      igstTotal += base * (toNumber(row.igst_percentage) / 100);
    });

    const adjVal = isFirstTrans ? (isAdd ? toNumber(adjustment) : -toNumber(adjustment)) : 0;
    const grossTotal = subTotal + cgstTotal + sgstTotal + igstTotal + adjVal;
    const roundedTotal = Math.round(grossTotal);
    const roundDiff = isRoundOff ? +(roundedTotal - grossTotal).toFixed(2) : 0;

    const totalTax = cgstTotal + sgstTotal + igstTotal;

    return {
      subTotal,
      cgstTotal,
      sgstTotal,
      igstTotal,
      totalTax,
      roundDiff,
      finalTotal: grossTotal + roundDiff,
    };
  }, [transactionType, productList, isRoundOff, adjustment, isAdd, isFirstTrans]);

  const summary = calculateSummary();

  const [isScheduled, setIsScheduled] = useState(false);

  return (
    <>
      <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
        <Toast show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide bg={snackbarStatus ? "success" : "danger"}>
          <Toast.Body className="text-white">{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      <ProfileImageModal show={showProfilePopup} onClose={() => setShowProfilePopup(false)} imageUrl={selectedProfile} />{" "}
      <div className="d-flex flex-column flex-xl-row">
        <Sidebar currentfile="Transactions" />
        <div className=" bg-half-white" style={{ background: "#F5F8FA", width: "calc(100% - 220px)" }}>
          <Navbar pageTitle="Transactions" />
          {/* Header bar */}
          <div className="transaction-header-wrapper">
            <div className="transaction-header-container">
              <div className="transaction-header-left">
                <img src={backArrow} className="btn-icon cursor-pointer" alt="back" onClick={() => navigate(-1)} />
                <span className="transaction-header-title">New transaction :</span>
                <div className="transaction-type-switch">
                  <div
                    onClick={() => {
                      handleClear();
                      setTransactionType("Purchase-Order");
                    }}
                    className={`transaction-type-pill ${transactionType === "Purchase-Order" ? "active" : "inactive"}`}
                  >
                    <div className={`transaction-pill-radio ${transactionType === "Purchase-Order" ? "active" : "inactive"}`}>{transactionType === "Purchase-Order" && <div className="transaction-radio-dot" />}</div>
                    Purchase order
                  </div>
                  <div
                    onClick={() => {
                      handleClear();
                      setTransactionType("Direct");
                    }}
                    className={`transaction-type-pill ${transactionType === "Direct" ? "active" : "inactive"}`}
                  >
                    <div className={`transaction-pill-radio ${transactionType === "Direct" ? "active" : "inactive"}`}>{transactionType === "Direct" && <div className="transaction-radio-dot" />}</div>
                    Direct
                  </div>
                </div>
              </div>

              <div className="transaction-header-right">
                {transactionType === "Direct" && (
                  <Button className={`header-btn btn-scan-action ${isScanLoading ? "skeleton-btn" : ""}`} onClick={handleScanClick} disabled={isScanLoading}>
                    {isScanLoading ? (
                      "Scanning..."
                    ) : (
                      <>
                        <img src={scanIcon} alt="scan" className="btn-icon" /> Scan
                      </>
                    )}
                  </Button>
                )}
                <Button className="header-btn btn-attach-action" onClick={() => setShowUploadModal(true)}>
                  <img src={attachPin} alt="attach" className="btn-icon" /> Attach
                </Button>
                <div className="header-divider"></div>
                <Button className="header-btn btn-cancel-action" onClick={() => navigate(-1)}>
                  Cancel
                </Button>
                <Button className={`header-btn btn-save-action ${isLoader ? "disabled-btn" : ""}`} onClick={!isLoader ? submitForm : null}>
                  {isLoader ? <Spinner animation="border" size="sm" /> : id != null ? "Update" : "Save"}
                </Button>
              </div>
            </div>
          </div>
          <div style={{ gap: "13px" }}>
            {/* TRANSACTION DETAILS */}
            <div className="trans-details-card">
              <div className="trans-details-header">
                <p className="trans-details-title">Transaction details</p>
                <div className="trans-details-actions">
                  <div className="d-flex align-items-center gap-2">
                    <img src={personIcon} alt="user" className="btn-icon" />
                    <span style={{ fontSize: "13px", fontWeight: "600", color: "#51515999" }}>{createdBy}</span>
                  </div>
                  <div className="header-divider"></div>
                  <div className="trans-date-picker-wrapper">
                    <span className="trans-date-label">Date :</span>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <DatePicker
                        selected={paymentDate}
                        onChange={(date) => {
                          setPaymentDate(date);
                          if (isScheduled && date && date <= new Date()) {
                            setErrorMsg((prev) => ({ ...prev, trans_date: "Scheduled date & time must be in the future" }));
                          } else {
                            setErrorMsg((prev) => ({ ...prev, trans_date: "" }));
                          }
                        }}
                        dateFormat="dd/MM/yyyy hh:mm a"
                        showTimeInput
                        maxDate={!isScheduled ? new Date() : undefined}
                        minDate={isScheduled ? new Date() : undefined}
                        customInput={
                          <div className={`trans-custom-date-input ${errorMsg.trans_date ? "is-error" : ""}`}>
                            <span>{paymentDate ? paymentDate.toLocaleString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: true, day: "2-digit", month: "2-digit", year: "numeric" }).toUpperCase() : "Select Date and Time"}</span>
                            <img src={calendarIcon} className="btn-icon" alt="calendar" />
                          </div>
                        }
                      />
                      {errorMsg.trans_date && <span className="trans-error-msg">{errorMsg.trans_date}</span>}
                    </div>
                  </div>
                  <div className="header-divider"></div>
                  <label className="trans-scheduled-toggle">
                    <input type="checkbox" className="trans-scheduled-checkbox" checked={isScheduled} onChange={(e) => setIsScheduled(e.target.checked)} />
                    <span className="trans-scheduled-label">Scheduled</span>
                  </label>
                </div>
              </div>

              <Row className="g-2">
                {transactionType === "Purchase-Order" ? (
                  <>
                    {/* Left Column - PO Based */}
                    <Col lg={6}>
                      <div className="trans-form-row">
                        <label className="trans-form-label">
                          Purchase Order <span style={{ color: "#ff0000" }}>*</span>
                        </label>
                        <div className="trans-form-input-container">
                          <CommonDropdown
                            apiUrl={`${apiUrl}get_purchase_order?po_status=Confirmed`}
                            placeholder="Select"
                            width="90%"
                            borderRadius="12px"
                            isError={!!errorMsg.po_id}
                            value={purchaseOrderOption}
                            onSelect={(item) => {
                              setPurchaseOrderOption(item);
                              getPODetails(item.value);
                            }}
                          />
                          {errorMsg.po_id && <span className="trans-error-msg">{errorMsg.po_id}</span>}
                        </div>
                      </div>

                      <div className="trans-form-row">
                        <label className="trans-form-label">Category</label>
                        <div className="trans-form-input-container">
                          <input type="text" className={`trans-input-field read-only ${errorMsg.category ? "is-error" : ""}`} placeholder="Auto -Fill" value={searchCategory} readOnly />
                        </div>
                      </div>

                      <div className="trans-form-row">
                        <label className="trans-form-label">
                          {" "}
                          Payment Type <span style={{ color: "red" }}>*</span>{" "}
                        </label>
                        <div className="trans-form-input-container">
                          <CommonDropdown apiUrl={`${apiUrl}get_payment_type?term=`} placeholder="Enter here..." width="90%" borderRadius="12px" isError={!!errorMsg.payment_type_id} value={paymentTypeOption} onSelect={(item) => setPaymentTypeOption(item)} />
                          {errorMsg.payment_type_id && <span className="trans-error-msg">{errorMsg.payment_type_id}</span>}
                        </div>
                      </div>

                      <div className="trans-form-row">
                        <label className="trans-form-label">
                          Vendor <span style={{ color: "#ff0000" }}>*</span>
                        </label>
                        <div className="trans-form-input-container">
                          <input type="text" className="trans-input-field read-only" placeholder="Auto -Fill" value={vendor} readOnly />
                        </div>
                      </div>

                      <div className="trans-form-row">
                        <label className="trans-form-label">Remarks</label>
                        <div className="trans-form-input-container">
                          <textarea className="trans-textarea-field" placeholder="Enter here..." rows={1} value={remarks} onChange={(e) => setRemarks(e.target.value)} />
                        </div>
                      </div>
                    </Col>

                    {/* Right Column - PO Based */}
                    <Col lg={6}>
                      <div className="trans-form-row">
                        <label className="trans-form-label">Project</label>
                        <div className="trans-form-input-container">
                          <CommonDropdown apiUrl={`${apiUrl}get_project?term=`} placeholder="Enter here..." width="90%" borderRadius="12px" isError={!!errorMsg.project_id} value={projectOption} onSelect={(item) => setProjectOption(item)} />
                          {errorMsg.project_id && <span className="trans-error-msg">{errorMsg.project_id}</span>}
                        </div>
                      </div>

                      <div className="trans-form-row">
                        <label className="trans-form-label">
                          Paying Amount <span style={{ color: "#ff0000" }}>*</span>
                        </label>
                        <div className="trans-form-input-container">
                          <input type="text" className={`trans-input-field ${errorMsg.amount ? "is-error" : ""}`} placeholder="Enter here..." value={payingAmount} readOnly />
                          {errorMsg.amount && <span className="trans-error-msg">{errorMsg.amount}</span>}
                        </div>
                      </div>

                      <div className="trans-form-row">
                        <label className="trans-form-label">Paid Amount</label>
                        <div className="trans-form-input-container">
                          <input type="text" className="trans-input-field read-only" placeholder="Auto -Fill" value={paidAmount} readOnly />
                        </div>
                      </div>

                      <div className="trans-form-row">
                        <label className="trans-form-label">Balance Amount</label>
                        <div className="trans-form-input-container">
                          <input type="text" className="trans-input-field read-only" placeholder="Auto -Fill" value={balanceAmount} readOnly />
                        </div>
                      </div>

                      <div className="trans-form-row">
                        <label className="trans-form-label">Total Amount</label>
                        <div className="trans-form-input-container">
                          <input type="text" className="trans-input-field read-only" placeholder="Auto -Fill" value={totalAmount} readOnly />
                        </div>
                      </div>
                    </Col>
                  </>
                ) : (
                  <>
                    {/* Left Column - Direct Based */}
                    <Col lg={6}>
                      <div className="trans-form-row">
                        <label className="trans-form-label">
                          Vendor <span style={{ color: "#ff0000" }}>*</span>
                        </label>
                        <div className="trans-form-input-container">
                          <CommonDropdown
                            apiUrl={`${apiUrl}get_vendor?term=`}
                            placeholder="Select"
                            width="90%"
                            borderRadius="12px"
                            isError={!!errorMsg.vendor_id}
                            value={vendorOption}
                            onSelect={(item) => {
                              setVendorOption(item);
                              getAddress(item.value);
                            }}
                          />
                          {errorMsg.vendor_id && <span className="trans-error-msg">{errorMsg.vendor_id}</span>}
                        </div>
                      </div>

                      <div className="trans-form-row">
                        <label className="trans-form-label">Project</label>
                        <div className="trans-form-input-container">
                          <CommonDropdown apiUrl={`${apiUrl}get_project?term=`} placeholder="Select" width="90%" borderRadius="12px" isError={!!errorMsg.project_id} value={projectOption} onSelect={(item) => setProjectOption(item)} />
                          {errorMsg.project_id && <span className="trans-error-msg">{errorMsg.project_id}</span>}
                        </div>
                      </div>

                      <div className="trans-form-row">
                        <label className="trans-form-label">Category</label>
                        <div className="trans-form-input-container">
                          <div className="d-flex align-items-center gap-2">
                            <CommonDropdown
                              apiUrl={`${apiUrl}get_category?term=`}
                              placeholder="Select"
                              width="90%"
                              borderRadius="12px"
                              isError={!!errorMsg.category_id}
                              value={selectedCategory}
                              onSelect={(item) => {
                                setSelectedCategory(item);
                                setSearchCategory(item.label);
                              }}
                            />
                            {/* <img src={addPlus} alt="add" className="cursor-pointer" style={{ width: "20px" }} onClick={() => setCreateCategoryModal(true)} /> */}
                          </div>
                          {errorMsg.category_id && <span className="trans-error-msg">{errorMsg.category_id}</span>}
                        </div>
                      </div>
                    </Col>

                    {/* Right Column - Direct Based */}
                    <Col lg={6}>
                      <div className="trans-form-row">
                        <label className="trans-form-label">
                          Payment type <span style={{ color: "#ff0000" }}>*</span>
                        </label>
                        <div className="trans-form-input-container">
                          <CommonDropdown apiUrl={`${apiUrl}get_payment_type?term=`} placeholder="Select" width="90%" borderRadius="12px" isError={!!errorMsg.payment_type_id} value={paymentTypeOption} onSelect={(item) => setPaymentTypeOption(item)} />
                          {errorMsg.payment_type_id && <span className="trans-error-msg">{errorMsg.payment_type_id}</span>}
                        </div>
                      </div>

                      <div className="trans-form-row">
                        <label className="trans-form-label">
                          Paying Amount <span style={{ color: "#ff0000" }}>*</span>
                        </label>
                        <div className="trans-form-input-container">
                          <input type="text" className={`trans-input-field ${errorMsg.amount ? "is-error" : ""}`} placeholder="Enter amount" value={payingAmount} readOnly />
                          {errorMsg.amount && <span className="trans-error-msg">{errorMsg.amount}</span>}
                        </div>
                      </div>

                      <div className="trans-form-row">
                        <label className="trans-form-label">Remarks</label>
                        <div className="trans-form-input-container">
                          <textarea className="trans-textarea-field" placeholder="Enter here..." rows={1} value={remarks} onChange={(e) => setRemarks(e.target.value)} />
                        </div>
                      </div>
                    </Col>
                  </>
                )}
              </Row>
            </div>
            {/* PRODUCT DETAILS */}
            <div className="product-details-card">
              <div className="product-header">
                <div className="d-flex align-items-center gap-3">
                  <p className="product-title m-0">Products</p>
                  {errorMsg.products && <span className="trans-error-msg m-0">{errorMsg.products}</span>}
                </div>

                <div className="product-stats">
                  <div className="stat-pill total-qty">
                    Total Qty :{" "}
                    <CommonTooltip text={productList.reduce((acc, row) => acc + toNumber(row.total_quantity || 0), 0).toLocaleString("en-IN")} ellipsis={true} className="stat-value" style={{ color: "#2C8C53" }}>
                      {productList.reduce((acc, row) => acc + toNumber(row.total_quantity || 0), 0).toLocaleString("en-IN")}
                    </CommonTooltip>
                  </div>
                  <div className="stat-pill balance-qty">
                    Balance Qty :{" "}
                    <CommonTooltip text={productList.reduce((acc, row) => acc + toNumber(row.balance_quantity || 0), 0).toLocaleString("en-IN")} ellipsis={true} className="stat-value" style={{ color: "#F97316" }}>
                      {productList.reduce((acc, row) => acc + toNumber(row.balance_quantity || 0), 0).toLocaleString("en-IN")}
                    </CommonTooltip>
                  </div>
                  <div className="stat-pill received-qty">
                    Received Qty :{" "}
                    <CommonTooltip text={productList.reduce((acc, row) => acc + toNumber(row.quantity || 0), 0).toLocaleString("en-IN")} ellipsis={true} className="stat-value" style={{ color: "#4F46E5" }}>
                      {productList.reduce((acc, row) => acc + toNumber(row.quantity || 0), 0).toLocaleString("en-IN")}
                    </CommonTooltip>
                  </div>
                  <div className="stat-pill tax-amount">
                    Tax Amount :{" "}
                    <CommonTooltip text={`${currencySymbol}${summary.totalTax.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`} ellipsis={true} className="stat-value" style={{ color: "#097BED" }}>
                      {currencySymbol}{summary.totalTax.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                    </CommonTooltip>
                  </div>
                  <div className="stat-pill total-amount">
                    Total Amount :{" "}
                    <CommonTooltip text={`${currencySymbol}${summary.finalTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`} ellipsis={true} className="stat-value" style={{ color: "#EF4444" }}>
                      {currencySymbol}{summary.finalTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                    </CommonTooltip>
                  </div>
                </div>
              </div>

              <div className="product-table-wrapper" style={{ border: "none" }}>
                <table className="product-table" style={{ border: "none" }}>
                  <thead>
                    <tr>
                      {productList.some((_, index) => getErrorMsg(index, "exception")) && transactionType === "Direct" && <th style={{ width: "80px" }}>Proceed</th>}
                      <th>Product Name</th>
                      <th>Product ID</th>
                      {transactionType === "Purchase-Order" && <th>Total Qty</th>}
                      {transactionType === "Purchase-Order" && <th>Balance Qty</th>}
                      <th>{transactionType === "Purchase-Order" ? "Received Qty" : "Quantity"}</th>
                      {transactionType === "Direct" && <th>Amount (per unit)</th>}
                      {isCgst && <th>CGST (%)</th>}
                      {isIgst && <th>IGST (%)</th>}
                      {isSgst && <th>SGST (%)</th>}
                      <th>Amount</th>
                      {transactionType === "Direct" && <th className="delete-action-col" style={{ width: "36px" }}></th>}
                    </tr>
                  </thead>
                  <tbody>
                    {productList.length > 0 ? (
                      productList.map((row, index) => {
                        let quantityError = getErrorMsg(index, "exception");
                        return (
                          <tr key={row.id || index}>
                            {productList.some((_, index) => getErrorMsg(index, "exception")) && transactionType === "Direct" && (
                              <td style={{ textAlign: "center" }}>
                                <input
                                  type="checkbox"
                                  checked={row.proceed ?? false}
                                  onChange={(e) => {
                                    const productTemp = [...productList];
                                    productTemp[index]["proceed"] = e.target.checked;
                                    setProductList(productTemp);
                                  }}
                                  style={{ cursor: "pointer" }}
                                />
                              </td>
                            )}
                            <td style={{ minWidth: "220px" }}>
                              {transactionType === "Purchase-Order" ? (
                                <div className="table-input read-only d-flex align-items-center">{row.name}</div>
                              ) : (
                                <CommonDropdown
                                  apiUrl={`${apiUrl}get_product?term=`}
                                  placeholder="Select"
                                  value={row.product}
                                  onSelect={(item) => {
                                    const updated = [...productList];
                                    updated[index]["product"] = item;
                                    setProductList(updated);
                                    getProductDetails(item.value, index);
                                  }}
                                />
                              )}
                              {getErrorMsg(index, "product_id") && <span className="trans-error-msg">{getErrorMsg(index, "product_id")}</span>}
                              {quantityError && <span className="trans-error-msg">{quantityError}</span>}
                            </td>
                            <td style={{ width: "150px" }}>
                              <div className="table-input read-only d-flex align-items-center">{transactionType === "Purchase-Order" ? row.code : row.product_code}</div>
                            </td>
                            {transactionType === "Purchase-Order" && (
                              <td style={{ width: "120px" }}>
                                <div className="table-input read-only d-flex align-items-center">{row.total_quantity}</div>
                              </td>
                            )}
                            {transactionType === "Purchase-Order" && (
                              <td style={{ width: "120px" }}>
                                <div className="table-input read-only d-flex align-items-center">{row.balance_quantity}</div>
                              </td>
                            )}
                            <td style={{ width: "140px" }}>
                              <input
                                type="text"
                                className="table-input"
                                placeholder="Enter qty"
                                value={row.quantity}
                                onChange={(e) => {
                                  var value = e.target.value.replace(/[^0-9.]/g, "");
                                  const productTemp = [...productList];
                                  if (transactionType === "Direct" || value <= Number(row.balance_quantity ?? 0)) {
                                    productTemp[index]["quantity"] = value;
                                    setProductList(productTemp);
                                  }
                                  updateProductTotal(index);
                                }}
                              />
                              {getErrorMsg(index, "quantity") && <span className="trans-error-msg">{getErrorMsg(index, "quantity")}</span>}
                            </td>
                            {transactionType === "Direct" && (
                              <td style={{ width: "140px" }}>
                                <input
                                  type="number"
                                  className="table-input"
                                  placeholder="Enter amount"
                                  value={row.unit_amount}
                                  onChange={(e) => {
                                    const updated = [...productList];
                                    updated[index].unit_amount = e.target.value;
                                    setProductList(updated);
                                    updateProductTotal(index);
                                  }}
                                />
                              </td>
                            )}
                            {isCgst && (
                              <td style={{ width: "100px" }}>
                                {transactionType === "Purchase-Order" ? (
                                  <div className="table-input read-only d-flex align-items-center">{row.cgst_percentage}</div>
                                ) : (
                                  <input
                                    type="text"
                                    className="table-input"
                                    placeholder="%"
                                    value={row.cgst_percentage}
                                    onChange={(e) => {
                                      let value = e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
                                      const updated = [...productList];
                                      updated[index].cgst_percentage = value;
                                      setProductList(updated);
                                      updateProductTotal(index);
                                    }}
                                  />
                                )}
                              </td>
                            )}
                            {isIgst && (
                              <td style={{ width: "100px" }}>
                                {transactionType === "Purchase-Order" ? (
                                  <div className="table-input read-only d-flex align-items-center">{row.igst_percentage}</div>
                                ) : (
                                  <input
                                    type="text"
                                    className="table-input"
                                    placeholder="%"
                                    value={row.igst_percentage}
                                    onChange={(e) => {
                                      let value = e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
                                      const updated = [...productList];
                                      updated[index].igst_percentage = value;
                                      setProductList(updated);
                                      updateProductTotal(index);
                                    }}
                                  />
                                )}
                              </td>
                            )}
                            {isSgst && (
                              <td style={{ width: "100px" }}>
                                {transactionType === "Purchase-Order" ? (
                                  <div className="table-input read-only d-flex align-items-center">{row.sgst_percentage}</div>
                                ) : (
                                  <input
                                    type="text"
                                    className="table-input"
                                    placeholder="%"
                                    value={row.sgst_percentage}
                                    onChange={(e) => {
                                      let value = e.target.value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
                                      const updated = [...productList];
                                      updated[index].sgst_percentage = value;
                                      setProductList(updated);
                                      updateProductTotal(index);
                                    }}
                                  />
                                )}
                              </td>
                            )}
                            <td style={{ width: "150px" }}>
                              <CommonTooltip text={(row.amount || row.total_amount || 0).toString()} ellipsis={true} className="table-input read-only d-flex align-items-center">
                                {row.amount || row.total_amount || 0}
                              </CommonTooltip>
                              {getErrorMsg(index, "amount") && <span className="trans-error-msg">{getErrorMsg(index, "amount")}</span>}
                            </td>
                            {transactionType === "Direct" && (
                              <td className="delete-action-col">
                                <img
                                  src={deleteIcon}
                                  alt="delete"
                                  className="cursor-pointer"
                                  style={{ width: "14px" }}
                                  onClick={() => {
                                    const productListTemp = [...productList];
                                    const [removed] = productListTemp.splice(index, 1);
                                    if (removed && removed.id && removed.id !== 0) {
                                      setRemovedProducts([...removedProducts, removed.id]);
                                    }
                                    setProductList(productListTemp);
                                  }}
                                />
                              </td>
                            )}
                          </tr>
                        );
                      })
                    ) : (
                      <tr style={{ border: "none" }}>
                        <td colSpan={12} className="text-center pt-4 no-products-text" style={{ border: "none" }}>
                          No products added yet. Click "Add Product" to begin.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className={`d-flex ${productList.length === 0 ? "justify-content-center" : "justify-content-between"} align-items-start mt-0`}>
                {transactionType !== "Purchase-Order" && (
                  <button
                    className="btn-add-product"
                    style={{ border: "none" }}
                    onClick={() => {
                      setProductList([...productList, { id: 0, proceed: null, product: null, product_code: null, quantity: 0, amount: 0, cgst_percentage: 0, sgst_percentage: 0, igst_percentage: 0 }]);
                    }}
                  >
                    <img src={addPlus} alt="add" /> Add product
                  </button>
                )}

                {productList.length > 0 && (
                  <div className="summary-container ms-auto">
                    <div className="summary-row subtotal">
                      <span className="summary-label">Sub Total</span>
                      <CommonTooltip text={`${currencySymbol}${summary.subTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`} ellipsis={true} className="summary-value">
                        {currencySymbol}{summary.subTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                      </CommonTooltip>
                    </div>
                    <div className="summary-divider"></div>
                    <div className="summary-row">
                      <span className="summary-label">Total Discount</span>
                      <CommonTooltip text={`${currencySymbol}0.00`} ellipsis={true} className="summary-value">
                        {currencySymbol}0.00
                      </CommonTooltip>
                    </div>
                    <div className="summary-row">
                      <span className="summary-label">GST</span>
                      <CommonTooltip text={`${currencySymbol}${(summary.cgstTotal + summary.sgstTotal + summary.igstTotal).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`} ellipsis={true} className="summary-value">
                        {currencySymbol}{(summary.cgstTotal + summary.sgstTotal + summary.igstTotal).toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                      </CommonTooltip>
                    </div>
                    <div className="summary-row">
                      <span className="summary-label">Adjustments {!isFirstTrans && "(Already added)"}</span>
                      <CommonTooltip text={`${isFirstTrans ? (isAdd ? "+" : "-") : ""}${isFirstTrans ? toNumber(adjustment).toLocaleString("en-IN", { minimumFractionDigits: 2 }) : "0.00"}`} ellipsis={true} className="summary-value">
                        {isFirstTrans ? (isAdd ? "+" : "-") : ""}
                        {isFirstTrans ? toNumber(adjustment).toLocaleString("en-IN", { minimumFractionDigits: 2 }) : "0.00"}
                      </CommonTooltip>
                    </div>
                    <div className="summary-round-off-pill">
                      <span className="summary-label">Round-off</span>
                      <input type="checkbox" className="trans-roundoff-checkbox" checked={isRoundOff} onChange={(e) => setIsRoundOff(e.target.checked)} />
                    </div>
                    <div className="summary-divider"></div>
                    <div className="summary-row total">
                      <span className="summary-label">Total Amount</span>
                      <CommonTooltip text={`${currencySymbol}${summary.finalTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}`} ellipsis={true} className="summary-value">
                        {currencySymbol}{summary.finalTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
                      </CommonTooltip>
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* ATTACHMENTS */}
            <div className="attachment-card-wrapper">
              <p className="attachment-title">Attachment</p>

              <div className="attachment-grid">
                {attachmentURLList.map((item, index) => {
                  const isImage = (item.file_name || "").toLowerCase().match(/\.(png|jpg|jpeg|gif|webp)$/);
                  return (
                    <div className={`attachment-file-card ${scanningFile === item.file ? "is-scanning" : ""}`} key={`url-${index}`}>
                      {scanningFile === item.file && <div className="scanning-overlay" />}
                      <div className="file-icon-wrapper">
                        <img src={isImage ? item.file : pdfIcon} alt="file" className={isImage ? "file-preview-img" : "file-type-icon"} onClick={() => openFile(item.file, item.file_name)} />
                      </div>
                      <div className="file-details">
                        <CommonTooltip text={item.file_name} ellipsis={true} className="file-display-name">
                          {item.file_name}
                        </CommonTooltip>
                        <div className="file-info-row">
                          <span className="file-display-size">Existing File</span>
                          {transactionType === "Direct" && !scannedFiles.includes(item.file) && (
                            <button
                              className="btn-scan-on-card"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleScanOnCard(item.file);
                              }}
                            >
                              Scan
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        {scanningFile !== item.file && (
                          <button
                            className="btn-remove-attachment"
                            onClick={(e) => {
                              e.stopPropagation();
                              setRemovedAttachmentList([...removedAttachmentList, item.id]);
                              setAttachmentURLList(attachmentURLList.filter((_, i) => i !== index));
                            }}
                          >
                            <img src={closeAttachment} alt="remove" className="delete-btn-icon" />
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}

                {attachmentList.map((item, index) => {
                  const isImage = item.base64 && item.base64.startsWith("data:image/");
                  return (
                    <div className={`attachment-file-card ${scanningFile === item.name ? "is-scanning" : ""}`} key={`new-${index}`}>
                      {scanningFile === item.name && <div className="scanning-overlay" />}
                      <div className="file-icon-wrapper">
                        <img src={isImage ? item.base64 : pdfIcon} alt="file" className={isImage ? "file-preview-img" : "file-type-icon"} />
                      </div>
                      <div className="file-details">
                        <CommonTooltip text={item.name} ellipsis={true} className="file-display-name">
                          {item.name}
                        </CommonTooltip>
                        <div className="file-info-row">
                          <span className="file-display-size">{item.size}</span>
                          {transactionType === "Direct" && !scannedFiles.includes(item.name) && (
                            <button
                              className="btn-scan-on-card"
                              onClick={(e) => {
                                e.stopPropagation();
                                const base64Str = item.base64.split(",")[1];
                                setScanningFile(item.name);
                                extractBill(base64Str);
                              }}
                            >
                              Scan
                            </button>
                          )}
                        </div>
                      </div>
                      {scanningFile !== item.name && (
                        <button
                          className="btn-remove-attachment"
                          onClick={(e) => {
                            e.stopPropagation();
                            setAttachmentList(attachmentList.filter((_, i) => i !== index));
                          }}
                        >
                          <img src={closeAttachment} alt="remove" className="delete-btn-icon" />
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>

              <div className={`upload-drop-zone ${dragging ? "dragging" : ""}`} onClick={handleInputFile} onDrop={handleDrop} onDragOver={(e) => e.preventDefault()} onDragEnter={() => setDragging(true)} onDragLeave={() => setDragging(false)}>
                <div className="upload-main-icon">
                  <img src={fileAdd} alt="upload" style={{ width: "40px", height: "40px", objectFit: "contain" }} />
                </div>
                <p className="upload-main-text">Drag and drop your files</p>
                <p className="upload-sub-text">Supported formats: JPEG, PNG, PDF (Max 5 MB)</p>

                <div className="upload-button-group">
                  <button
                    className="btn-upload-option"
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowUploadModal(true);
                      startCamera();
                    }}
                  >
                    <img src={cameraIcon} alt="camera" style={{ width: "18px", height: "18px", objectFit: "contain" }} /> Camera
                  </button>
                  <button
                    className="btn-upload-option"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleInputFile();
                    }}
                  >
                    <img src={addAttach} alt="add" style={{ width: "18px", height: "18px", objectFit: "contain" }} /> Select File
                  </button>
                </div>
                <input type="file" ref={fileInputRef} className="d-none" multiple onChange={handleFileChange} />
              </div>
              {errorMsg.attachment && (
                <span className="trans-error-msg mt-2 d-block text-danger" style={{ fontSize: "12px" }}>
                  {errorMsg.attachment}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <Modal show={showUploadModal} onHide={() => setShowUploadModal(false)} centered className="file-upload-modal" size="lg">
        <div className="file-upload-header">
          <div>
            <h2 className="file-upload-title">{isCameraActive ? "Camera Capture" : "File Upload"}</h2>
            <p className="file-upload-subtitle">{isCameraActive ? "Align the document and capture for direct scanning." : "Choose an image file and upload securely to proceed."}</p>
          </div>
          <img
            src={closeModal}
            alt="close"
            className="file-upload-close"
            onClick={() => {
              setShowUploadModal(false);
              setTempAttachmentList([]);
              setIsScanAction(false);
              stopCamera();
            }}
          />
        </div>

        <canvas ref={canvasRef} style={{ display: "none" }} />

        {!isCameraActive && tempAttachmentList.length > 0 && (
          <div className="modal-file-list">
            {tempAttachmentList.map((file, idx) => (
              <div className="modal-file-item" key={idx}>
                <img src={file.type.startsWith("image/") ? file.base64 : pdfIcon} alt="preview" className="modal-file-preview" />
                <div className="modal-file-info">
                  <p className="modal-file-name">{file.name}</p>
                  <span className="modal-file-size">{file.size}</span>
                </div>
                <button className="btn-modal-remove" onClick={() => setTempAttachmentList(tempAttachmentList.filter((_, i) => i !== idx))}>
                  <img src={trashIcon} alt="delete" style={{ width: "18px" }} />
                </button>
              </div>
            ))}
          </div>
        )}

        {(isCameraActive || !isScanAction || tempAttachmentList.length === 0) && (
          <div className="modal-drop-zone-container">
            <div className="modal-drop-zone" style={isCameraActive ? { padding: "10px" } : {}}>
              {isCameraActive ? (
                <div className="camera-preview-container" style={{ width: "100%", height: "450px", position: "relative", overflow: "hidden", borderRadius: "12px" }}>
                  <video ref={videoRef} autoPlay playsInline muted style={{ width: "100%", height: "100%", objectFit: "contain", background: "#000" }} />
                </div>
              ) : (
                <>
                  <div className="upload-icon-circle">
                    <img src={fileAdd} alt="upload" style={{ width: "50px" }} />
                  </div>
                  <p className="drag-drop-text">Drag and drop your files</p>
                  <p className="format-info-text">Supported formats: JPEG, PNG, PDF (Max 5 MB)</p>

                  <div className="modal-upload-options">
                    <button type="button" className="btn-modal-option" onClick={startCamera}>
                      <img src={cameraIcon} alt="camera" style={{ width: "18px" }} />
                      Camera
                    </button>
                    <label className="btn-modal-option">
                      <img src={addAttach} alt="plus" style={{ width: "16px" }} />
                      Select File
                      <input type="file" multiple style={{ display: "none" }} onChange={handleModalFileChange} />
                    </label>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        <div className="modal-footer-custom">
          {isCameraActive ? (
            <>
              <button className="btn-modal-cancel" onClick={stopCamera}>
                Cancel
              </button>
              <button className="btn-modal-upload" onClick={capturePhoto}>
                Capture
              </button>
            </>
          ) : (
            <>
              <button
                className="btn-modal-cancel"
                onClick={() => {
                  setShowUploadModal(false);
                  setTempAttachmentList([]);
                  setIsScanAction(false);
                  stopCamera();
                }}
              >
                Cancel
              </button>
              <button className="btn-modal-upload" onClick={handleModalUpload}>
                Upload
              </button>
            </>
          )}
        </div>
      </Modal>
      {createCategoryModal && (
        <>
          {/* Backdrop */}
          <div className="modal-backdrop fade show" style={{ zIndex: 1040 }}></div>

          {/* Modal */}
          <div className="modal show d-block" tabIndex="-1" style={{ zIndex: 1050 }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content rounded-4 p-3">
                <div className="modal-header border-0">
                  <h5 className="modal-title fs-20 fw-700">New Category</h5>
                  <img
                    src=""
                    className="btn-icon cursor-pointer"
                    alt="close"
                    onClick={() => {
                      setCreateCategoryModal(false);
                      setErrorMsg({});
                      setCategoryName("");
                    }}
                  />
                </div>

                {/* Body */}
                <div className="modal-body">
                  <form>
                    <div className="mb-3">
                      <label className="form-label">Category Name</label>
                      <input type="text" className="form-control" placeholder="Enter Name" value={categoryName} onChange={(e) => setCategoryName(e.target.value)} />
                      <div>
                        {errorMsg.name && (
                          <span className="text-danger" style={{ fontSize: 12 }}>
                            {errorMsg.name}
                          </span>
                        )}
                      </div>
                    </div>
                  </form>
                </div>

                {/* Footer */}
                <div className="modal-footer gap-3 border-0">
                  <button
                    className="btn bg-transparent border px-3"
                    type="button"
                    onClick={() => {
                      setCreateCategoryModal(false);
                      setErrorMsg({});
                      setCategoryName("");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn text-white px-4 d-flex justify-content-center align-items-center"
                    type="button"
                    style={{
                      backgroundColor: "#4F46E5",
                      minWidth: "90px",
                      opacity: isSaveLoader ? 0.7 : 1,
                      height: "40px",
                    }}
                    onClick={handleCategorySave}
                    disabled={isSaveLoader}
                  >
                    {isSaveLoader ? <span className="spinner-border spinner-border-sm" role="status"></span> : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default TransactionCreate;
